<div class="table-section">
    <mat-expansion-panel [expanded]="expandPanel" class="mat-elevation-z0 expansion-panel w-full">
        <mat-expansion-panel-header class="bg-black-100 expansion-panel-header justify-center">
            <div class="title">
              Daily Food and Drinks
            </div>
            <div class="flex">
                <app-icon class="light-icon" svgIcon="red-light"></app-icon>
                <span class="red-light-label">Total Red Lights: {{totalRl}}</span>
            </div>
        </mat-expansion-panel-header>
        <div class="table-container">
            <table [dataSource]="dataSource" class="mat-elevation-z8" mat-table>
                <ng-container [sticky]="true" matColumnDef="mealTime">
                    <th *matHeaderCellDef class="min-w-[18rem]" mat-header-cell>
                        <div class="th-cell">
                            Meal Time
                        </div>
                    </th>
                    <td *matCellDef="let eachRow;let index=index" mat-cell>
                        <div class="td-cell">
                            <div class="daily-tracker-title text-wrapper">
                                {{eachRow.typeText}}
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="myFood">
                    <th *matHeaderCellDef class="min-w-[15rem]" mat-header-cell>
                        <div class="th-cell daily-tracker-title">
                            My Foods & Drinks
                        </div>
                    </th>
                    <td *matCellDef="let eachRow" mat-cell>
                        <div class="td-cell daily-tracker-content daily-tracker-title text-wrapper">
                            {{eachRow?.food}}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="amounts">
                    <th *matHeaderCellDef class="min-w-[15rem]" mat-header-cell>
                        <div class="th-cell daily-tracker-title">
                          No. of servings
                        </div>
                    </th>
                    <td *matCellDef="let eachRow" mat-cell>
                        <div class="td-cell daily-tracker-content daily-tracker-title text-wrapper">
                            {{eachRow?.serving}} Serving
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="lightCount">
                    <th *matHeaderCellDef class="min-w-[15rem]" mat-header-cell>
                        <div class="th-cell daily-tracker-title">
                            Lights Count
                        </div>
                    </th>
                    <td *matCellDef="let eachRow" mat-cell>
                        <div class="td-cell daily-tracker-content daily-tracker-title">
                            <app-icon class="light-icon" svgIcon="red-light" *ngIf="eachRow.color === 1"></app-icon>
                            <app-icon class="light-icon" svgIcon="green-light" *ngIf="eachRow.color === 2"></app-icon>
                            <app-icon class="light-icon" svgIcon="yellow-light" *ngIf="eachRow.color === 3"></app-icon>
                            {{eachRow?.points }}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="comments">
                    <th *matHeaderCellDef class="min-w-[15rem] max-w-[15rem]" mat-header-cell>
                        <div class="th-cell daily-tracker-title">
                            Comments
                        </div>
                    </th>
                    <td *matCellDef="let eachRow" mat-cell class="min-w-[15rem] max-w-[15rem]">
                        <div class="td-cell daily-tracker-content daily-tracker-title text-wrapper"
                             [matTooltip]="eachRow?.comments"
                             [matTooltipDisabled]="!eachRow?.comments || eachRow?.comments?.length <= 50"
                             matTooltipClass="custom-tooltip">
                            {{ eachRow?.comments?.length > 50 ? (eachRow?.comments | slice:0:50) + '...' : eachRow?.comments }}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef class="min-w-[5rem] w-[5rem]" mat-header-cell>
                        <div class="th-cell survey-title">
                            <!--Status-->
                        </div>
                    </th>
                    <td *matCellDef="let eachRow" mat-cell>
                        <div class="td-cell menu survey-content survey-title">
                            <button [matMenuTriggerFor]="menu" mat-icon-button>
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button class="duplicate-menu-button" mat-menu-item (click)="onEditClicked(eachRow)"> Edit
                                </button>
                                <button class="duplicate-menu-button" mat-menu-item (click)="onDeleteRecord(eachRow)">Delete
                                </button>
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>
                <tr *matHeaderRowDef="colDef; sticky: true" mat-header-row></tr>
                <tr *matRowDef="let row; columns: colDef;" mat-row></tr>
            </table>
            <div *ngIf="loading" [ngClass]="{ 'initial': !dataSource?.data?.length }"
                class="table-loader w-full flex justify-center items-center">
                <mat-spinner/>
            </div>
            <div *ngIf="!dataSource?.length && !loading" class="no-data flex flex-col justify-center items-center">
                <div class="text">
                    No Data Found
                </div>
            </div>
        </div>
    </mat-expansion-panel>


</div>

<div class="add-new-section flex justify-center items-center" *ngIf="!loading">
    <app-icon class="add-icon" svgIcon="add" (click)="addDailyMeal()"></app-icon>
    <span class="add-button-label" (click)="addDailyMeal()">Add Food or Drink</span>
</div>
